/** @format */

import { HeaderCheckBoxSelectListElement } from '../../lib/search/listTableHeader/HeaderCheckBoxSelectList';

/** @fromat */

export const iccidStateInt = {
    FREE: 0,
    USED: 1,
    PLANNED: 2,
    LOCK: 3,
    ARCHIVE: 4,
};

export const iccidStateI18n = {
    FREE: 'pools:state.free',
    USED: 'pools:state.used',
    PLANNED: 'pools:state.planned',
    LOCK: 'pools:state.lock',
    ARCHIVE: 'pools:sim.scrap',
};

export class IccidState {
    getStatusList = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: iccidStateInt.PLANNED, name: iccidStateI18n.PLANNED },
            { value: iccidStateInt.FREE, name: iccidStateI18n.FREE },
            { value: iccidStateInt.USED, name: iccidStateI18n.USED },
            { value: iccidStateInt.ARCHIVE, name: iccidStateI18n.ARCHIVE },
        ];
    };
}
